import React from "react";
import { Modal } from "antd";
import { BorderedButton } from "../../commonComponents";
import "./SignInModal.scss";

const SignInModal = ({ visible, closeModal }) => {
  return (
    <>
      <Modal
        open={visible}
        title={"Log in first before joining any games"}
        onCancel={closeModal}
        wrapClassName="excluded-warning-modal"
        className="excluded-warning-modal-inner cc-join-popup"
        footer={null}
        maskStyle={{
          backdropFilter: "blur(5px)",
        }}
      >
        <div className="deposit-modal-buttons">
          <BorderedButton
            name={"OK"}
            btnClass="alert-buttons-discard"
            functionCall={closeModal}
          />
        </div>
      </Modal>
    </>
  );
};
export default SignInModal;
